import { Box, HStack, Tag, Text } from '@chakra-ui/react';

import { EVENT_MAPPINGS } from '@/constants/analytics';
import {
  DISCONTINUED_BADGE_BG,
  DISCONTINUED_BADGE_COLOR,
} from '@/constants/constants';
import { trackEvent } from '@/dapp-sdk-v2';
import { getDiscontinuedNetwork } from '@/utils/discontinued';

type Props = {
  label: string;
  items: Array<{
    label: string;
    detailId: string;
    link: string;
    tag?: string;
    dataKey?: string;
  }>;
};

const Column = ({ label: title, items }: Props) => {
  return (
    <Box textAlign="left" w={244}>
      <Text
        fontSize={{ base: 20, lg: 22.5 }}
        fontWeight={{ base: 600, lg: 700 }}
        mb={{ base: 3, lg: 4 }}
      >
        {title}
      </Text>
      {items.map(({ detailId, label, link, tag, dataKey }) => {
        const discontinued = getDiscontinuedNetwork(dataKey);
        const badge = tag ?? discontinued?.badge;
        // A CMS tag ("NEW") is a promo and keeps the accent colour. "Discontinued"
        // is the opposite signal, so it stays muted against the dark footer.
        const isMutedBadge = !tag && !!discontinued;
        // The retired dApp is gone — point at the discontinuation notice instead.
        const href = discontinued?.learnMoreUrl ?? link;
        return (
          <HStack key={detailId} align="center" gap={3} opacity={0.7} mb={3}>
            <Text
              fontSize={{ base: 12, lg: 18 }}
              lineHeight={{ base: '15px', lg: '21px' }}
              as="a"
              display="block"
              href={href}
              target="_blank"
              rel={title === 'Networks' ? 'canonical' : 'noopener noreferrer'}
              key={detailId}
              onClick={() => {
                trackEvent(EVENT_MAPPINGS[title.toLowerCase()] || title, {
                  cta: 'footer',
                  name: label,
                });
              }}
            >
              {label}
            </Text>
            {badge && (
              <Tag
                className="tag"
                bg={isMutedBadge ? DISCONTINUED_BADGE_BG : '#2196F3'}
                color={isMutedBadge ? DISCONTINUED_BADGE_COLOR : 'white'}
                minH="auto"
                py="3px"
                px="8px"
                borderRadius="full"
                textTransform="uppercase"
              >
                <Text
                  fontSize="9px"
                  fontWeight={700}
                  letterSpacing="0.6px"
                  lineHeight="1"
                >
                  {badge}
                </Text>
              </Tag>
            )}
          </HStack>
        );
      })}
    </Box>
  );
};

export default Column;
